<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
            </div>

            <div class="modal__main-icon modal__main-icon--user"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <div class="navigators">
                    <div class="navigator" @click="currentPage > 0 ? goTo(0) : null" :class="{
                        'navigator--active':
                            currentPage === 0 ||
                            currentPage === 1 ||
                            currentPage === 2 ||
                            currentPage === 3 ||
                            currentPage === 4,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"details"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(1)" :class="{
                        'navigator--active':
                            currentPage === 1 ||
                            currentPage === 2 ||
                            currentPage === 3 ||
                            currentPage === 4,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"contact"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(2)" :class="{
                        'navigator--active':
                            currentPage === 2 ||
                            currentPage === 3 ||
                            currentPage === 4,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"rights"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(3)" :class="{
                        'navigator--active':
                            currentPage === 3 ||
                            currentPage === 4,
                    }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"invoice"}`) }}
                        </div>
                    </div>

                    <div class="navigator" @click="goTo(4)" :class="{ 'navigator--active': currentPage === 4 }">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addUserModal.${"image"}`) }}
                        </div>
                    </div>
                </div>

                <form class="add__form" :class="{ 'add__form-full': (currentPage == 2) }">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <transition name="fade" mode="out-in">
                                <div class="details" key="0" v-if="currentPage === 0">
                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <VSelect :options="genders" :reduce="(gender) => gender.id"
                                                :placeholder="$t(`addPrivateCostumerModal.gender`)" label="name"
                                                v-model="userDetails.gender" class="select select--default"
                                                :class="{ 'select--error': genderHasError }" />
                                            <div class="form__error" v-if="genderHasError">
                                                {{ $t(`addUserModal.${"genderErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect :options="titles" :reduce="(title) => title.id"
                                                :placeholder="$t(`addPrivateCostumerModal.title`)" label="name"
                                                v-model="userDetails.titleId" class="select select--default" />
                                        </div>
                                    </div>

                                    <!-- <div class="form__field">
                                        <div class="company">
                                            <label class="company__title" for="company">{{
                                                $t(`addPrivateCostumerModal.company`) }} </label>
                                            <div class="checkbox">
                                                <input type="checkbox" id="company" class="checkbox__checkbox"
                                                    v-model="userDetails.company" />
                                                <label for="company" class="checkbox__label"></label>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.company`)"
                                            v-model="userDetails.companyName" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.firstName`)"
                                            v-model="userDetails.firstName" :class="{
                                                'input--error': firstNameHasError,
                                            }" />
                                        <div class="form__error" v-if="firstNameHasError">
                                            {{ firstNameErrorPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.lastName`)"
                                            v-model="userDetails.lastName"
                                            :class="{ 'input--error': lastNameHasError }" />
                                        <div class="form__error" v-if="lastNameHasError">
                                            {{ lastNameErrorPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <Datepicker class="input input--default" :class="{
                                                'input--error': birthdayHasError,
                                            }" :config="statics.datePickerConfig"
                                                :placeholder="$t(`addPrivateCostumerModal.birthdate`)"
                                                v-model="userDetails.birthday" />
                                            <div class="form__error" v-if="birthdayHasError">
                                                {{ $t(`addUserModal.${"birthdateErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double">
                                            <VSelect :options="languages" :reduce="(language) => language.id"
                                                :placeholder="$t(`addPrivateCostumerModal.language`)" label="name"
                                                v-model="userDetails.language" class="select select--default"
                                                :class="{ 'select--error': languageHasError }" />
                                            <div class="form__error" v-if="languageHasError">
                                                {{ $t(`addUserModal.${"languageErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.street`)"
                                                v-model="userAddress[0].street"
                                                :class="{ 'input--error': streetHasError }" />
                                            <div class="form__error" v-if="streetHasError">
                                                {{ $t(`addPrivateCostumerModal.${"streetErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double form__field--nr">
                                            <input type="text" class="input input--default" placeholder="Nr."
                                                v-model="userAddress[0].number"
                                                :class="{ 'input--error': numberHasError }" />
                                            <div class="form__error" v-if="numberHasError">
                                                {{ $t(`addPrivateCostumerModal.${"numberErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.zip`)"
                                                v-model="userAddress[0].zip" :class="{ 'input--error': zipHasError }" />

                                            <div class="form__error" v-if="zipHasError">
                                                {{ zipCodePlaceholder }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double">
                                            <VSelect v-if="zipCodeData.length > 1" :options="zipCodeData"
                                                :reduce="(city) => city.city"
                                                :placeholder="$t(`addPrivateCostumerModal.city`)" label="city"
                                                v-model="userAddress[0].city" class="select select--default" :class="{
                                                    'input--error': cityHasError,
                                                }" />

                                            <div v-else-if="zipCodeData.length"
                                                class="input input--default input--readonly"
                                                :class="{ 'input--error': cityHasError }">
                                                {{ userAddress[0].city }}
                                            </div>

                                            <input v-else-if="!zipCodeData.length" type="text"
                                                class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.city`)"
                                                v-model="userAddress[0].city"
                                                :class="{ 'input--error': cityHasError }" />

                                            <div class="form__error" v-if="cityHasError">
                                                {{ $t(`addUserModal.${"cityErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="contact" key="1" v-else-if="currentPage === 1">
                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="E-mail *"
                                            v-model="userContact.email" :class="{ 'input--error': emailHasError }" />
                                        <div class="form__error" v-if="emailHasError">
                                            {{ emailPlaceholder }}
                                        </div>
                                    </div>

                                    <div class="form__field form__field--prefix">
                                        <div class="form__row">
                                            <div class="form__input-wrapper">
                                                <input type="text" class="input input--default"
                                                    :placeholder="$t(`addPrivateCostumerModal.phone`)"
                                                    v-model="userContact.phone"
                                                    :class="{ 'input--error': phoneHasError }" />
                                                <div class="form__error" v-if="phoneHasError">
                                                    {{ phoneErrorPlaceholder }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <VSelect :options="countries" :reduce="(country) => country.code"
                                            :placeholder="$t(`addPrivateCostumerModal.nationality`)" label="name"
                                            v-model="userContact.countryCode" class="select select--default" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="AHV Nr."
                                            v-model="userContact.ahvNr" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.bank`)"
                                            v-model="userBanks[0].name" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default"
                                            :placeholder="$t(`addPrivateCostumerModal.account`)"
                                            v-model="userBanks[0].account" />
                                    </div>

                                    <div class="form__field">
                                        <input type="text" class="input input--default" placeholder="Finma Nr."
                                            v-model="userContact.finmaNr" />
                                    </div>
                                </div>

                                <div class="rights" key="2" v-else-if="currentPage === 2">
                                    <div class="form__field">
                                        <div class="company">
                                            <label class="company__title" for="innendienst">
                                                {{ $t(`addPrivateCostumerModal.${"internalSales"}`) }}
                                            </label>
                                            <div class="checkbox">
                                                <input type="checkbox" id="innendienst" class="checkbox__checkbox"
                                                    v-model="userDetails.visibleToAll" />
                                                <label for="innendienst" class="checkbox__label"></label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <VSelect :options="visibleTeams" :reduce="(team) => team"
                                            :placeholder="$t(`addPrivateCostumerModal.teams`)" label="name"
                                            @update:modelValue="selectTeams($event)" class="select select--default"
                                            v-model="teamsInput" :class="{ 'select--error': teamHasError }" />
                                        <div class="form__error" v-if="teamHasError">
                                            {{ $t(`addUserModal.${"teamErrorMsg"}`) }}
                                        </div>

                                        <div class="selected-teams" v-if="(visibleUserTeams || []).length">
                                            <div class="team" v-for="teamEntry in visibleUserTeams"
                                                :key="teamEntry.teamId">
                                                <div class="team-wrapper">
                                                    <div class="tab">
                                                        {{ getTeamDisplayName(teamEntry.teamId) }}
                                                        <div class="tab__delete"
                                                            @click="removeTeamTab(teamEntry.teamId)"></div>
                                                    </div>
                                                    <div class="form__field">
                                                        <VSelect :options="getTeamRoles(teamEntry.teamId)"
                                                            :reduce="(role) => role.id"
                                                            :placeholder="$t(`addPrivateCostumerModal.userRights`)"
                                                            label="title" :modelValue="roleInputs[teamEntry.teamId]"
                                                            @update:modelValue="selectRoles($event, teamEntry.teamId)"
                                                            class="select select--default"
                                                            :class="{ 'select--error': rolesHasError[teamEntry.teamId] }" />
                                                        <div class="form__error" v-if="!(teamEntry.roles || []).length">
                                                            {{ $t(`addUserModal.${"roleErrorMsg"}`) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tabs" v-if="(teamEntry.roles || []).length">
                                                    <div class="tab right-tab" v-for="roleId in teamEntry.roles"
                                                        :key="roleId">
                                                        {{(roles.find((r) => r.id === roleId) || {}).title}}
                                                        <div class="tab__delete"
                                                            @click="removeRoleTab(teamEntry.teamId, roleId)"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <template
                                        v-if="(userRights.teamId || []).length === 0 && (teamsInput || '').length === 0">
                                        <div class="form__field disabled-el">
                                            <VSelect :placeholder="$t(`addPrivateCostumerModal.supervisor`)" disabled
                                                class="select select--default" />
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="form__field">
                                            <VSelect :options="users" :reduce="(user) => user.id"
                                                :placeholder="$t(`addPrivateCostumerModal.supervisor`)" :getOptionLabel="(user) => `${user.first_name} ${user.last_name}`
                                                    " v-model="userRights.supervisorId"
                                                class="select select--default" />
                                        </div>
                                    </template>
                                </div>

                                <div class="rights" key="3" v-else-if="currentPage === 3">
                                    <template
                                        v-if="(userRights.teamId || []).length === 0 && (userRights.teams || []).length === 0">
                                        <div class="form__field disabled-el">
                                            <VSelect disabled placeholder="Abrechnungsgruppe *"
                                                class="select select--default" />
                                        </div>

                                        <div class="form__field disabled-el">
                                            <div class="details__option">
                                                <label class="details__option-name" for="stornokonto">{{
                                                    $t(`addPrivateCostumerModal.${"cancellation"}`) }}</label>
                                                <div class="checkbox">
                                                    <input disabled type="checkbox" id="stornokonto"
                                                        class="checkbox__checkbox" />
                                                    <label for="stornokonto" class="checkbox__label"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="form__field">
                                            <VSelect :options="saleCategories" :reduce="(sale) => sale.id"
                                                :getOptionLabel="(sale) => `${sale.name}`"
                                                :placeholder="$t(`addPrivateCostumerModal.billingGroup`)" label="name"
                                                v-model="userRights.salesCategoryId" class="select select--default"
                                                :class="{ 'select--error': salesHasError }" />
                                            <div class="form__error" v-if="salesHasError">
                                                {{ $t(`addUserModal.${"categorySaleErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field">
                                            <VSelect :options="saleCategories2" :reduce="(category) => category.id"
                                                :placeholder="$t(`addPrivateCostumerModal.accompanyingCommission`)"
                                                :getOptionLabel="getCategoryLabel"
                                                @update:modelValue="selectSaleCat2($event)"
                                                class="select select--default" v-model="salesCategoryId2" />

                                            <div class="tabs" v-if="(userRights.salesCategoryId2 || []).length">
                                                <div class="tab" v-for="category in (userRights.salesCategoryId2 || [])"
                                                    :key="category">
                                                    {{(saleCategories2.find((r) => r.id === category) || {}).name}}
                                                    <div class="tab__delete" @click="removeCategoryTab(category)"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form__field">
                                            <div class="details__option">
                                                <label class="details__option-name" for="stornokonto">{{
                                                    $t(`addPrivateCostumerModal.${"cancellation"}`) }}</label>
                                                <div class="checkbox">
                                                    <input type="checkbox" id="stornokonto" class="checkbox__checkbox"
                                                        v-model="hasDepositEnabled" />
                                                    <label for="stornokonto" class="checkbox__label"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double">
                                            <input v-if="hasDepositEnabled" type="text" class="input input--default"
                                                :placeholder="$t(`addPrivateCostumerModal.cancellation`)"
                                                v-model="userRights.max_deposit" />
                                        </div>
                                    </template>
                                </div>

                                <div class="logo" key="4" v-else-if="currentPage === 4">
                                    <div class="add__avatar">
                                        <img v-if="userImage" :src="userImage" alt="" ref="userImageRef" />
                                        <div v-else class="add__avatar-empty">
                                            <img class="add__avatar-empty"
                                                src="../assets/icons/default/Bold 2px-profile_circled-white.svg"
                                                alt="" />
                                        </div>
                                    </div>
                                    <div class="add__upload-text">
                                        {{ $t(`addPrivateCostumerModal.${"uploadImg"}`) }}
                                    </div>
                                    <div class="add__upload-wrapper">
                                        <button type="button" class="button button--default button--upload"
                                            @click="uploadFileRef?.click()">
                                            {{ $t(`addPrivateCostumerModal.${"uploadImg"}`) }}
                                        </button>
                                        <input ref="uploadFileRef" type="file" class="add__upload"
                                            @change="uploadImage($event)" />
                                    </div>

                                    <div class="signature" v-if="isEdit && editingUser.hasSignature">
                                        <button type="button" class="button button--default clear-btn"
                                            @click="resetSignature">
                                            {{ $t(`customerSignature.${"resetBtn"}`) }}
                                        </button>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </transition>
                </form>
            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>
            <button v-else type="button" class="modal__button modal__button--submit button button--default"
                @click="currentPage !== 4 ? goForward() : createUser()">
                <span v-if="currentPage === 4">{{ $t(`addUserModal.${"saveBtn"}`) }}</span>
                <span v-else>{{ $t(`addUserModal.${"next"}`) }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import parseFieldErrors from "@/helpers/parseFieldErrors";
import { normalizeUserTeamsForEdit } from "@/helpers/userTeamFormState";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
defineOptions({
    name: "AddUserModal"
});

const store = useStore();
const route = useRoute();

// Element references
const uploadFileRef = ref(null);
const userImageRef = ref(null);

// Reactive Local States
const currentPage = ref(0);
const editingUser = ref("");
const image = ref("");
const file = ref("");
const confirmPassword = ref("");
const confirmPasswordPlaceholder = ref("");
const confirmPasswordHasError = ref(false);
const userImage = ref("");
const formLoading = ref(false);
const isRequesting = ref(false);
const specificErrors = ref([]);
const taxes = ref([]);
const teamsInput = ref("");
const roleInputs = reactive({});
const salesCategoryId2 = ref([]);

// Error Mapping Flags
const firstNameHasError = ref(false);
const lastNameHasError = ref(false);
const genderHasError = ref(false);
const birthdayHasError = ref(false);
const languageHasError = ref(false);
const streetHasError = ref(false);
const numberHasError = ref(false);
const zipHasError = ref(false);
const cityHasError = ref(false);
const emailHasError = ref(false);
const phonePrefixHasError = ref(false);
const phoneHasError = ref(false);
const rolesHasError = reactive({});
const salesHasError = ref(false);
const teamHasError = ref(false);

const zipCodePlaceholder = ref("");
const emailPlaceholder = ref("");
const firstNameErrorPlaceholder = ref("");
const lastNameErrorPlaceholder = ref("");
const phonePrefixErrorPlaceholder = ref("");
const phoneErrorPlaceholder = ref("");

// Validation structures
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const userDetails = reactive({
    gender: "",
    titleId: "",
    company: false,
    companyName: "",
    firstName: "",
    lastName: "",
    birthday: "",
    language: "",
    visibleToAll: false,
});

const userContact = reactive({
    email: "",
    phonePrefix: "",
    phone: "",
    countryCode: "",
    ahvNr: "",
    finmaNr: ""
});

const userRights = reactive({
    supervisorId: "",
    roles: [],
    salesCategoryId: "",
    salesCategoryId2: [],
    teamId: [],
    teams: [],
    has_deposit: 0,
    max_deposit: '',
});

const ensureArray = (value) => Array.isArray(value) ? value : [];
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canAccessTeams = computed(() => {
    if (isSuperAdmin.value) return true;

    const teamIds = store.getters.authorizedTeamIds("team_access");
    return teamIds === null || teamIds.length > 0;
});
const userAddress = reactive([{
    street: "",
    number: "",
    city: "",
    zip: "",
}]);

const userBanks = reactive([{
    name: "",
    account: "",
}]);

// Global store mappings (Replaces mapGetters)
const userForms = computed(() => store.getters.userForms);
const isEdit = computed(() => store.getters.isEdit);
const userToEdit = computed(() => store.getters.userToEdit);

const saleCategories2 = computed(() => userForms.value ? userForms.value["secondary-sales-categories"] : []);
const roles = computed(() => {
    const formRoles = userForms.value ? userForms.value.roles : [];
    if (Array.isArray(formRoles) && formRoles.length) {
        return formRoles;
    }

    return Array.isArray(store.getters.roles) ? store.getters.roles : [];
});
const users = computed(() => userForms.value ? userForms.value.supervisors : []);
const teams = computed(() => userForms.value ? userForms.value.teams : []);
const visibleTeamIds = computed(() => {
    if (isSuperAdmin.value) {
        return Array.from(new Set((Array.isArray(teams.value) ? teams.value : []).map((team) => Number(team?.id)).filter((id) => Number.isInteger(id) && id > 0)));
    }

    const visibleIds = store.getters.authorizedTeamIds("team_access");
    const allowedFromCatalog = Array.isArray(teams.value)
        ? teams.value.map((team) => Number(team?.id)).filter((id) => Number.isInteger(id) && id > 0)
        : [];

    if (visibleIds === null) {
        return Array.from(new Set(allowedFromCatalog));
    }

    return Array.from(new Set((Array.isArray(visibleIds) ? visibleIds : []).map((id) => Number(id)).filter((id) => Number.isInteger(id) && id > 0)));
});
const visibleTeams = computed(() => {
    const catalogTeams = Array.isArray(teams.value) ? teams.value : [];
    return catalogTeams.filter((team) => visibleTeamIds.value.includes(Number(team?.id)));
});
const visibleUserTeams = computed(() => {
    return ensureArray(userRights.teams).filter((teamEntry) => {
        const teamId = Number(teamEntry?.teamId);
        return Number.isInteger(teamId) && teamId > 0;
    });
});
const genders = computed(() => userForms.value ? userForms.value.genders : []);
const titles = computed(() => userForms.value ? userForms.value.titles : []);
const languages = computed(() => userForms.value ? userForms.value.languages : []);
const countries = computed(() => userForms.value ? userForms.value.countries : []);
const saleCategories = computed(() => userForms.value ? userForms.value["sales-categories"] : []);
const hasDepositEnabled = computed({
    get() {
        return !!Number(userRights.has_deposit);
    },
    set(value) {
        userRights.has_deposit = value ? 1 : 0;

        if (!value) {
            userRights.max_deposit = '';
        }
    },
});

const zipCodeData = computed({
    get() {
        return store.state.zipCodes.zipCodeData;
    },
    set(value) {
        store.commit("setZipCodeData", value);
    },
});

const zip = computed(() => userAddress[0].zip);
const city = computed(() => userAddress[0].city);

const getUserId = (user) => (user && typeof user === "object" ? user.id : user);

// Functional validation definitions
const loadCities = async (value) => {
    await store.dispatch("getZipCodeData", value);
    userAddress[0].zip = value;
    userAddress[0].city = zipCodeData.value[0]?.city || "";
};

const validateUserDetails = (callback) => {
    const { firstName, lastName, gender, language } = userDetails;
    const { zip, city, street, number } = userAddress[0];

    if (!firstName) {
        firstNameHasError.value = true;
        firstNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`);
    } else {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    }

    if (!lastName) {
        lastNameHasError.value = true;
        lastNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`);
    } else {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    }

    genderHasError.value = !gender;
    languageHasError.value = !language;
    streetHasError.value = !street;
    numberHasError.value = !number;

    if (!zip) {
        zipHasError.value = true;
        zipCodePlaceholder.value = t(`addCompanyContactModal.${"zipErrorMsg"}`);
    }

    cityHasError.value = !city;

    if (
        !firstNameHasError.value &&
        !lastNameHasError.value &&
        !birthdayHasError.value &&
        !genderHasError.value &&
        !languageHasError.value &&
        !streetHasError.value &&
        !numberHasError.value &&
        !zipHasError.value &&
        !cityHasError.value
    ) {
        callback(true);
    }
};

const validateUserContact = (callback) => {
    const { email, phone } = userContact;
    if (!email) {
        emailHasError.value = true;
        emailPlaceholder.value = t(`addPrivateCostumerModal.${"emailRequired"}`);
    }
    if (!phone) {
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"phoneRequired"}`);
    }
    if (
        !emailHasError.value &&
        !phoneHasError.value &&
        !phonePrefixHasError.value
    ) {
        callback(true);
    }
};

const syncUserRightsState = () => {
    const filteredTeams = ensureArray(userRights.teams).reduce((accumulator, teamEntry) => {
        const teamId = Number(teamEntry?.teamId);
        if (!Number.isInteger(teamId) || teamId <= 0) {
            return accumulator;
        }

        const normalizedRoles = ensureArray(teamEntry?.roles).filter((role) => role !== null && role !== undefined && role !== "");
        accumulator.push({
            teamId,
            name: teamEntry?.name || "",
            roles: normalizedRoles,
        });

        return accumulator;
    }, []);

    if (filteredTeams.length !== ensureArray(userRights.teams).length) {
        userRights.teams = filteredTeams;
    } else {
        userRights.teams = filteredTeams;
    }

    userRights.teamId = filteredTeams.map((teamEntry) => teamEntry.teamId);
    userRights.roles = filteredTeams.flatMap((teamEntry) => ensureArray(teamEntry.roles));
};

const validateUserRights = (callback) => {
    const { teams } = userRights;
    const normalizedTeams = ensureArray(teams).filter((teamEntry) => {
        const teamId = Number(teamEntry?.teamId);
        return Number.isInteger(teamId) && teamId > 0;
    });

    normalizedTeams.forEach((teamEntry) => {
        rolesHasError[teamEntry.teamId] = !(teamEntry.roles || []).length;
    });

    const hasAnyRolesError = !normalizedTeams.length || normalizedTeams.some((teamEntry) => rolesHasError[teamEntry.teamId]);

    if (!(userRights.teamId || []).length && canAccessTeams.value) {
        teamHasError.value = true;
    }

    if (!hasAnyRolesError && !teamHasError.value) {
        callback(true);
    }
};

const validateUserInvoice = (callback) => {
    const { salesCategoryId } = userRights;
    salesHasError.value = !salesCategoryId;

    if (!salesHasError.value) {
        callback(true);
    }
};

const reconcileSalesCategorySelection = () => {
    const availableSalesCategories = Array.isArray(saleCategories.value) ? saleCategories.value : [];
    const availableSecondarySalesCategories = Array.isArray(saleCategories2.value) ? saleCategories2.value : [];
    const selectedPrimaryCategoryId = userRights.salesCategoryId;
    const availableSecondaryIds = availableSecondarySalesCategories.map((category) => String(category?.id));

    const matchingPrimaryCategory = availableSalesCategories.find((category) => {
        return String(category?.id) === String(selectedPrimaryCategoryId);
    });

    if (selectedPrimaryCategoryId && !matchingPrimaryCategory) {
        userRights.salesCategoryId = "";
    } else if (matchingPrimaryCategory && selectedPrimaryCategoryId !== matchingPrimaryCategory.id) {
        userRights.salesCategoryId = matchingPrimaryCategory.id;
    }

    userRights.salesCategoryId2 = (userRights.salesCategoryId2 || []).filter((categoryId) => {
        return availableSecondaryIds.some((availableId) => String(availableId) === String(categoryId));
    });
};

const validateTeams = (callback) => {
    const teamId = ensureArray(userRights.teamId);

    if (!teamId.length && canAccessTeams.value) {
        teamHasError.value = true;
    }

    if (!teamHasError.value) {
        callback(true);
    }
};

// Structural State Synchronizers (Replaces watch options block)
watch(() => userDetails.gender, (value) => {
    genderHasError.value = !value;
});

watch(() => userDetails.firstName, (value) => {
    if (value) {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    } else {
        firstNameHasError.value = true;
        firstNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`);
    }
});

watch(() => userDetails.lastName, (value) => {
    if (value) {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    } else {
        lastNameHasError.value = true;
        lastNameErrorPlaceholder.value = t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`);
    }
});

watch(() => userDetails.language, (value) => {
    languageHasError.value = !value;
});

watch(() => userAddress[0].street, (value) => {
    streetHasError.value = !value;
});

watch(() => userAddress[0].number, (value) => {
    numberHasError.value = !value;
});

watch(zip, async (newZip) => {
    if (newZip) {
        zipHasError.value = false;
        zipCodePlaceholder.value = "";

        if (newZip >= 1000 && newZip <= 9999) {
            await loadCities(newZip);
        } else {
            zipCodeData.value = [];
            userAddress[0].city = "";
            zipHasError.value = true;
            zipCodePlaceholder.value = t(`addPrivateCostumerModal.${"invalidZip"}`);
        }
    } else {
        userAddress[0].city = "";
        zipHasError.value = true;
        zipCodePlaceholder.value = t(`addCompanyContactModal.${"zipErrorMsg"}`);
    }
});

watch(city, (value) => {
    cityHasError.value = !value;
});

watch(() => userContact.email, (value) => {
    if (value) {
        emailHasError.value = false;
        emailPlaceholder.value = "";

        if (!emailRegex.test(value.toLowerCase())) {
            emailHasError.value = true;
            emailPlaceholder.value = t(`addPrivateCostumerModal.${"invalidEmail"}`);
        }
    } else {
        emailHasError.value = true;
        emailPlaceholder.value = t(`addPrivateCostumerModal.${"emailRequired"}`);
    }
});

watch(() => userContact.phonePrefix, (value) => {
    if (!value) {
        phonePrefixHasError.value = true;
        phonePrefixErrorPlaceholder.value = t(`addPrivateCostumerModal.${"invalidPrefix"}`);
    } else {
        phonePrefixHasError.value = false;
        phonePrefixErrorPlaceholder.value = "";
    }
});

watch(() => userContact.phone, (value) => {
    if (value) {
        if (!statics.phoneRegex.test(value)) {
            phoneHasError.value = true;
            phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"invalidPhone"}`);
        } else {
            phoneHasError.value = false;
            phoneErrorPlaceholder.value = "";
        }
    } else {
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = t(`addPrivateCostumerModal.${"phoneRequired"}`);
    }
});

watch(() => userRights.teams, (value) => {
    const teams = ensureArray(value);

    teams.forEach((teamEntry) => {
        rolesHasError[teamEntry.teamId] = !(teamEntry.roles || []).length;
    });
}, { deep: true });

watch(() => userRights.salesCategoryId, (value) => {
    salesHasError.value = !value;
});

watch(() => userRights.teamId, (value) => {
    const teamIds = ensureArray(value);
    if (teamIds.length) {
        teamHasError.value = false;
    } else {
        teamHasError.value = true;
        teamsInput.value = '';
    }
});

watch(confirmPassword, (value) => {
    if (value) {
        confirmPasswordPlaceholder.value = "";
        confirmPasswordHasError.value = false;
        if (value !== userRights.password) {
            confirmPasswordPlaceholder.value = t(`addPrivateCostumerModal.${"passwordDontMatch"}`);
            confirmPasswordHasError.value = true;
        }
    } else {
        confirmPasswordPlaceholder.value = t(`addPrivateCostumerModal.${"passwordRequired"}`);
        confirmPasswordHasError.value = true;
    }
});

watch(specificErrors, (errors) => {
    const errorKeys = errors.map((error) => error.errorKey);

    if (errorKeys.includes("email")) {
        currentPage.value = 1;
        emailHasError.value = true;
        emailPlaceholder.value = errors.find((error) => error.errorKey === "email").errorValue;
    } else {
        emailHasError.value = false;
        emailPlaceholder.value = "";
    }

    if (errorKeys.includes("phone")) {
        currentPage.value = 1;
        phoneHasError.value = true;
        phoneErrorPlaceholder.value = errors.find((error) => error.errorKey === "phone").errorValue;
    } else {
        phoneHasError.value = false;
        phoneErrorPlaceholder.value = "";
    }

    if (errorKeys.includes("first_name")) {
        currentPage.value = 0;
        firstNameErrorPlaceholder.value = errors.find((error) => error.errorKey === "first_name").errorValue;
        firstNameHasError.value = true;
    } else {
        firstNameHasError.value = false;
        firstNameErrorPlaceholder.value = "";
    }

    if (errorKeys.includes("last_name")) {
        currentPage.value = 0;
        lastNameErrorPlaceholder.value = errors.find((error) => error.errorKey === "last_name").errorValue;
        lastNameHasError.value = true;
    } else {
        lastNameHasError.value = false;
        lastNameErrorPlaceholder.value = "";
    }
});

// UI Action Boundaries
const getTeamDisplayName = (teamId) => {
    const normalizedTeamId = Number(teamId);

    const visibleTeam = visibleTeams.value.find((team) => Number(team?.id) === normalizedTeamId);
    if (visibleTeam?.name) {
        return visibleTeam.name;
    }

    const catalogTeam = teams.value.find((team) => Number(team?.id) === normalizedTeamId);
    if (catalogTeam?.name) {
        return catalogTeam.name;
    }

    const selectedTeam = ensureArray(userRights.teams).find((entry) => Number(entry?.teamId) === normalizedTeamId);
    return selectedTeam?.name || selectedTeam?.team?.name || "";
};

const getTeamRoles = (teamId) => {
    const allRoles = Array.isArray(roles.value) ? roles.value : [];

    if (!teamId) {
        return allRoles;
    }

    if (!visibleTeamIds.value.includes(Number(teamId)) && !teams.value.some((team) => Number(team?.id) === Number(teamId))) {
        return [];
    }

    return allRoles.filter((role) => {
        const roleTeamId = role?.team_id ?? role?.teamId ?? role?.team?.id;
        return Number(roleTeamId) === Number(teamId);
    });
};

const getCategoryLabel = (category) => {
    const name = category?.name;

    return name || "";
};

const closeModal = () => {
    store.commit("setShowAddUserModal", false);
    store.commit("setIsEdit", false);
    zipCodeData.value = [];
};

const loadFieldsForEdit = (userToEdit) => {
    const {
        company_name,
        ahv_number,
        finma_nr,
        visible_to_all,
        birthday,
        country,
        email,
        first_name,
        gender,
        language,
        last_name,
        phone,
        prefix,
        photo,
        roles: loadedRoles = [],
        sales_category,
        second_sales_category = [],
        supervisor,
        teams: loadedTeams = [],
        title,
        user_addresses = [],
        user_banks = [],
        taxes: loadedTaxes = [],
        has_deposit = 0,
        max_deposit = null
    } = userToEdit || {};

    userDetails.company = !!company_name;
    userDetails.companyName = company_name || "";
    userContact.ahvNr = ahv_number || "";
    userContact.finmaNr = finma_nr || "";
    userDetails.visibleToAll = !!visible_to_all;
    userDetails.birthday = birthday || "";
    userContact.countryCode = country?.code || "";
    userContact.email = email || "";
    userDetails.firstName = first_name || "";
    userDetails.gender = gender?.id || "";
    userDetails.language = language?.id || "";
    userDetails.lastName = last_name || "";
    userContact.phone = phone || "";
    userContact.phonePrefix = prefix || "";
    userImage.value = photo?.thumbnail || "";

    userRights.salesCategoryId = sales_category?.id || "";
    userRights.salesCategoryId2 = Array.isArray(second_sales_category) && second_sales_category.length ? second_sales_category.map(sale => sale.id) : [];
    userRights.supervisorId = supervisor?.id || "";

    const normalizedTeams = normalizeUserTeamsForEdit(loadedTeams, visibleTeamIds.value);

    userRights.teams = normalizedTeams.map((team) => {
        const teamRoles = (loadedRoles || []).filter((role) => {
            const roleTeamId = role?.team_id ?? role?.teamId ?? role?.team?.id;
            return roleTeamId === team.teamId || Number(roleTeamId) === Number(team.teamId);
        }).map((role) => role.id);

        if (teamRoles.length) {
            roleInputs[team.teamId] = teamRoles[0];
        } else {
            delete roleInputs[team.teamId];
        }

        return {
            teamId: team.teamId,
            name: team.name || "",
            roles: teamRoles,
        };
    });
    syncUserRightsState();
    userDetails.titleId = title?.id || "";

    userAddress[0] = {
        id: user_addresses[0]?.id || "",
        street: user_addresses[0]?.street || "",
        number: user_addresses[0]?.number || "",
        city: user_addresses[0]?.city || "",
        zip: user_addresses[0]?.zip || ""
    };

    userBanks[0] = {
        id: user_banks[0]?.id || "",
        name: user_banks[0]?.name || "",
        account: user_banks[0]?.account || ""
    };
    userRights.has_deposit = Number(has_deposit) || 0;
    userRights.max_deposit = max_deposit || '';
    taxes.value = loadedTaxes;
};

const goBack = () => {
    currentPage.value--;
    if (currentPage.value < 0) {
        closeModal();
        store.commit("setShowAddCustomerModal", true);
    }
};

const goTo = (page) => {
    if (page === 1) {
        validateUserDetails((state) => {
            if (state) currentPage.value = page;
        });
    } else if (page === 2) {
        validateUserDetails((detailsState) => {
            validateUserContact((contactState) => {
                if (contactState && detailsState) currentPage.value = page;
            });
        });
    } else if (page === 3) {
        validateUserDetails((detailsState) => {
            validateUserContact((contactState) => {
                validateUserRights((rightsState) => {
                    if (contactState && detailsState && rightsState) currentPage.value = page;
                });
            });
        });
    } else if (page === 4) {
        validateUserDetails((detailsState) => {
            validateUserContact((contactState) => {
                validateUserRights((rightsState) => {
                    validateUserInvoice((invoiceState) => {
                        if (contactState && detailsState && rightsState && invoiceState) currentPage.value = page;
                    });
                });
            });
        });
    } else {
        currentPage.value = page;
    }
};

const goForward = () => {
    if (currentPage.value < 4) {
        if (currentPage.value === 0) {
            validateUserDetails((state) => {
                if (state) currentPage.value++;
            });
        } else if (currentPage.value === 1) {
            validateUserContact((state) => {
                if (state) currentPage.value++;
            });
        } else if (currentPage.value === 2) {
            if ((userRights.teamId || []).length === 0) {
                validateTeams((state) => { if (state) return; });
            } else {
                validateUserRights((state) => {
                    if (state) currentPage.value++;
                });
            }
        } else if (currentPage.value === 3) {
            if ((userRights.teamId || []).length === 0) {
                validateTeams((state) => { if (state) return; });
            } else {
                validateUserInvoice((state) => {
                    if (state) currentPage.value++;
                });
            }
        }
    }
};

const removeRoleTab = (teamId, roleId) => {
    const teamEntry = userRights.teams.find((entry) => entry.teamId === teamId);
    if (!teamEntry) return;

    teamEntry.roles = teamEntry.roles.filter((role) => role !== roleId);
    syncUserRightsState();
    roleInputs[teamId] = null;
};

const removeCategoryTab = (categoryId) => {
    userRights.salesCategoryId2 = userRights.salesCategoryId2.filter((category) => category !== categoryId);
};

const removeTeamTab = async (teamId) => {
    userRights.teams = ensureArray(userRights.teams).filter((entry) => entry.teamId !== teamId);
    delete roleInputs[teamId];
    delete rolesHasError[teamId];
    syncUserRightsState();

    teamsInput.value = "";
    teamHasError.value = false;

    await store.dispatch("getUserFormsEdit", userRights.teamId);
    reconcileSalesCategorySelection();
};

const selectRoles = (value, teamId) => {
    const teamEntry = userRights.teams.find((entry) => entry.teamId === teamId);
    if (!teamEntry) return;

    if (!teamEntry.roles.includes(value)) {
        teamEntry.roles = [...teamEntry.roles, value];
        syncUserRightsState();
    }

    roleInputs[teamId] = value;
};

const selectSaleCat2 = (value) => {
    if (!userRights.salesCategoryId2.includes(value)) {
        userRights.salesCategoryId2 = [...userRights.salesCategoryId2, value];
    }
};

const selectTeams = async (value) => {
    if (!value?.id) return;

    const selectedTeamId = Number(value.id);
    if (!Number.isInteger(selectedTeamId) || selectedTeamId <= 0 || !visibleTeamIds.value.includes(selectedTeamId)) {
        return;
    }

    userRights.teams = ensureArray(userRights.teams);
    if (!userRights.teams.some((entry) => Number(entry.teamId) === selectedTeamId)) {
        userRights.teams = [...userRights.teams, { teamId: selectedTeamId, roles: [] }];
    }

    syncUserRightsState();

    if (!isEdit.value) {
        userRights.salesCategoryId = null;
    }

    teamsInput.value = "";
    await store.dispatch("getUserFormsEdit", userRights.teamId);
    reconcileSalesCategorySelection();
};

const uploadImage = (event) => {
    file.value = event.target.files[0];
    userImage.value = URL.createObjectURL(file.value);
};

const createUser = async () => {
    isRequesting.value = true;
    if (isEdit.value) {
        image.value = editingUser.value.photo ? editingUser.value.photo.file_name : "";
    }

    const { visibleToAll, ...userDetailsWithoutVisibility } = userDetails;

    const user = {
        ...userDetailsWithoutVisibility,
        ...userContact,
        ...userRights,
        phone: userContact.phone,
        prefix: userContact.phonePrefix,
        file: file.value,
        user_addresses: userAddress,
        user_banks: userBanks,
        teams: userRights.teamId,
        roles: userRights.roles,
        visibleToAll,
        settings: {
            locale: languages.value.find((lang) => lang.id === userDetails.language)?.code,
        },
    };

    try {
        if (isEdit.value) {
            const userId = getUserId(userToEdit.value);

            if (route.name === "AccountDetails" && user.file) {
                await store.dispatch("addUserPhoto", {
                    userId,
                    file: user.file,
                });
            }

            const userResponse = await store.dispatch("updateUser", {
                user: userRights.password ? { ...user, confirmPassword: confirmPassword.value } : user,
                userId,
            });
            store.commit("setUser", userResponse);

            if (route.name === "Reports") {
                await store.dispatch("getReportForms");
            }
        } else {
            await store.dispatch("createUser", user);
            store.commit("setToast", {
                display: true,
                type: "success",
                message: t("addPrivateCostumerModal.userAddedSuccessfully"),
            });
        }
        closeModal();
    } catch (err) {
        const { errors } = err.response.data;
        specificErrors.value = parseFieldErrors(errors);
        isRequesting.value = false;
    }
};

// Lifecycles implementations
onMounted(async () => {
    try {
        formLoading.value = true;
        let user = null;

        if (isEdit.value) {
            user = await store.dispatch("getUser", userToEdit.value);

            const userTeams = Array.isArray(user?.teams) ? user.teams : [];
            if (userTeams.length > 0) {
                const teamIds = userTeams.map(t => t.id);
                await store.dispatch("getUserFormsEdit", teamIds);
            } else if (user) {
                await store.dispatch("getUserForms");
            }

            editingUser.value = user;
            loadFieldsForEdit(user);
        } else {
            await store.dispatch("getUserForms");
        }
    } catch (error) {
        console.error("Error loading form data:", error);
    } finally {
        formLoading.value = false;
    }
});
</script>

<style lang="scss" scoped>
.add__form {
    width: 400px !important;
}


.clear-btn {
    width: 200px !important;
    margin: 0 auto;
    margin-top: 20px;
}

.disabled-el {
    .details__option {
        .checkbox {
            label {
                border: 1px solid #7F8FA480;
            }
        }
    }

    label {
        color: #7F8FA480 !important;
    }
}

.modal .navigators {
    width: 500px;
}

.company {
    display: flex;
    align-items: center;
    margin: 10px 0;

    &__title {
        color: var(--text-2);
        font-family: var(--muli-text-semi-bold);
        margin-right: 10px;
    }
}

.details {
    &__option {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &-name {
            color: var(--text-2);
            font-family: var(--muli-text-semi-bold);
            font-size: var(--x-small);
        }
    }
}

.team {
    padding: 20px 0;
    border-bottom: 1px solid var(--border-2);

    .team-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;

        .form__field {
            flex: 1;
            margin: 0;
        }

        .tab {
            padding: 10px 5px;
            margin: 0px;
            background: var(--bg-2);
            font-family: var(--muli-text-semi-bold);
            color: var(--text-1);
            border-radius: var(--radius-1);
            display: flex;
            transition: all 0.2s ease-in-out;
            position: relative;

            flex: 1;
        }


        .tab:hover {
            padding: 10px 25px 10px 5px;

            .tab__delete {
                opacity: 1;
                pointer-events: all;
                cursor: pointer;
            }
        }

        .tab__delete {
            position: absolute;
            right: 5px;
            opacity: 0;
            transition: all 0.2s ease-in-out;
            pointer-events: none;
            height: 15px;
            width: 15px;
            top: 50%;
            transform: translateY(-50%);
            background: url("../assets/icons/default/delete_icon_tab.svg") no-repeat;
        }
    }

    .tabs {
        gap: 5px;
        margin-top: 15px !important;
    }
}

.right-tab {
    background-color: var(--bg-3) !important;
    color: var(--text-2) !important;
    margin: 0px !important;

    .tab__delete {
        filter: invert(62%) sepia(11%) saturate(795%) hue-rotate(178deg) brightness(92%) contrast(89%);
    }
}

.add__form-full {
    width: 65% !important;
}

@media screen and (max-width: 500px) {
    .add__form {
        width: 100% !important;
    }

    .modal .navigators {
        width: 100%;

        .navigator__bullet {
            margin-right: 5px;
        }
    }

    .customer__form .form__input-wrapper {
        margin-bottom: 0px !important;
    }

    .form__field {
        margin-bottom: 20px !important;
    }
}
</style>
